import moment from 'moment';
import {
    APPOINTMENT_REQUEST_TIME_FORMAT
} from '@/components/sliding-widgets/appointment-request-widget/appointment-request-widget';
import { withParams } from 'vuelidate';

function timesAreSame(range) {
    const start = moment(range.start, APPOINTMENT_REQUEST_TIME_FORMAT);
    const end = moment(range.end, APPOINTMENT_REQUEST_TIME_FORMAT);

    return start.isSame(end);
}

function timeRangesOverlap(range1, range2) {
    const start1 = moment(range1.start, APPOINTMENT_REQUEST_TIME_FORMAT);
    const end1 = moment(range1.end, APPOINTMENT_REQUEST_TIME_FORMAT);

    const start2 = moment(range2.start, APPOINTMENT_REQUEST_TIME_FORMAT);
    const end2 = moment(range2.end, APPOINTMENT_REQUEST_TIME_FORMAT);

    return start1.isBefore(end2) && start2.isBefore(end1);
}

export function noTimeRangeOverlap(timeRanges) {
    const timeRangesInvalid = timeRanges.some((timeRange) => {
        const start = moment(timeRange.start, APPOINTMENT_REQUEST_TIME_FORMAT);
        const end = moment(timeRange.end, APPOINTMENT_REQUEST_TIME_FORMAT);

        return !start.isValid() || !end.isValid() || start.isAfter(end);
    });

    if (timeRangesInvalid) {
        return false;
    }

    const sortedTimeRanges = [...timeRanges].sort((a, b) =>
        moment(a.start, APPOINTMENT_REQUEST_TIME_FORMAT).diff(
            moment(b.start, APPOINTMENT_REQUEST_TIME_FORMAT),
        ),
    );

    if(sortedTimeRanges.length === 1 && timesAreSame(sortedTimeRanges[0])) {
        return false;
    }

    for (let i = 0; i < sortedTimeRanges.length - 1; i++) {
        const currentRange = sortedTimeRanges[i];
        if(timesAreSame(currentRange)) {
            return false;
        }

        const nextRange = sortedTimeRanges[i + 1];

        if (timeRangesOverlap(currentRange, nextRange)) {
            return false;
        }
    }

    return true;
}

export const hasTimeRanges = withParams(
    { type: 'hasTimeRanges' },
    (availability) =>
        Object.values(availability || {}).some((day) => Array.isArray(day) && day.length > 0)
);